var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { http } from "../client";
import qs from "query-string";
import { mapUserObjectToUser } from "../shared/user";
var URL = "clients";
var mapClient = function (client) { return (__assign(__assign({}, client), { user: client.user
        ? mapUserObjectToUser(client.user)
        : void 0 })); };
var getMany = function (_a) {
    var take = _a.take, username = _a.username, russianLegalEntityTitle = _a.russianLegalEntityTitle, skip = _a.skip, orderByDirection = _a.orderByDirection, orderBy = _a.orderBy;
    return http.api
        .get(URL, {
        params: {
            take: take,
            skip: skip,
            username: username,
            russian_legal_entity_title: russianLegalEntityTitle,
            orderBy: orderBy,
            orderByDirection: orderByDirection,
        },
        paramsSerializer: function (params) {
            return qs.stringify(params, { arrayFormat: "comma", skipEmptyString: true });
        },
    })
        .then(function (_a) {
        var _b = _a.data.data, total = _b.total, skip = _b.skip, take = _b.take, items = _b.items;
        return ({
            total: total,
            skip: skip,
            take: take,
            items: items.map(mapClient),
        });
    });
};
var create = function (request) {
    return http.api
        .post(URL, {
        user: {
            name: request.name,
            email: request.email,
            password: request.password,
            reset_password_after_10_days: request.resetPasswordAfter10Days,
        },
    })
        .then(function (res) { return mapClient(res.data.data); });
};
var getOne = function (id) {
    return http.api
        .get(URL + "/" + id)
        .then(function (res) { return mapClient(res.data.data); });
};
var update = function (id, request) {
    return http.api
        .put(URL + "/" + id, {
        show_details: request.showDetails,
        show_timetables: request.showTimetables,
        contract_number: request.contractNumber,
        contract_date: request.contractDate,
        legal_entity: request.legalEntity,
    })
        .then(function (res) { return res.data.data; });
};
var addSite = function (clientId, request) {
    return http.api.post(URL + "/" + clientId + "/sites", {
        name: request.name,
        area: request.area,
    });
};
var deleteSite = function (clientId, siteId) {
    return http.api.delete(URL + "/" + clientId + "/sites/" + siteId);
};
var mapClientActivityLog = function (object) { return ({
    id: object.id,
    clientId: object.client_id,
    userId: object.user_id,
    type: object.type,
    description: object.description,
    method: object.method,
    path: object.path,
    statusCode: object.status_code,
    ip: object.ip,
    userAgent: object.user_agent,
    context: object.context
        ? {
            trackId: object.context.track_id,
            trackTitle: object.context.track_title,
            artist: object.context.artist,
            deviceId: object.context.device_id,
            playDuration: object.context.play_duration,
            stopReason: object.context.stop_reason,
            playedAt: object.context.played_at,
        }
        : null,
    createdAt: object.created_at,
    client: object.client,
    user: object.user,
}); };
var getActivityLogs = function (clientId, request) {
    return http.api
        .get(URL + "/" + clientId + "/activity-logs", {
        params: request,
    })
        .then(function (res) { return res.data.data.map(mapClientActivityLog); });
};
var getAllActivityLogs = function (request) {
    return http.api
        .get("admin/client-activity-logs", {
        params: request,
    })
        .then(function (res) { return res.data.data.map(mapClientActivityLog); });
};
var getActivityLogFileInfo = function () {
    return http.api
        .get("admin/client-activity-log-file")
        .then(function (res) { return ({
        size: res.data.data.size,
        files: res.data.data.files.map(function (file) { return ({
            name: file.name,
            size: file.size,
            updatedAt: file.updated_at,
        }); }),
    }); });
};
var deleteActivityLogFile = function () {
    return http.api.delete("admin/client-activity-log-file");
};
var sendAccess = function (clientId) {
    return http.api.post(URL + "/" + clientId + "/send-access");
};
export var clientsApi = {
    getMany: getMany,
    create: create,
    getOne: getOne,
    update: update,
    addSite: addSite,
    deleteSite: deleteSite,
    getActivityLogs: getActivityLogs,
    getAllActivityLogs: getAllActivityLogs,
    getActivityLogFileInfo: getActivityLogFileInfo,
    deleteActivityLogFile: deleteActivityLogFile,
    sendAccess: sendAccess,
};
